module.exports = __webpack_public_path__ + "static/img/agentega.7862da4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/agentega.png
// module id = kAQa
// module chunks = 0